<template>
  <t-container class="consent-settings" data-qe-id="consent-settings">
    <t-text class="content">
      <h2>{{ $t('cookieConsent.main.title') }}</h2>
      <p>{{ $t('cookieConsent.main.text') }}</p>

      <div class="essential">
        <h3>{{ $t('cookieConsent.categoryEssential.title') }}</h3>
        <div class="checkbox-group">
          <input type="checkbox" checked disabled id="essential-box" />
          <label
            v-html="$t('cookieConsent.categoryEssential.text')"
            @click="() => {}"
            for="essential-box"
            data-qe-id="essential-accept-desc"
          >
          </label>
        </div>
        <t-toggle-box :title="$t('cookieConsent.main.moreinfo_textlink')" qe-id="xxx">
          <div v-html="md($t('cookieConsent.categoryEssential.details_md'))"></div>
        </t-toggle-box>
      </div>

      <div class="functional">
        <h3>{{ $t('cookieConsent.categoryFunctional.title') }}</h3>
        <div class="checkbox-group">
          <!-- TODO continue here with https://www.w3.org/WAI/ARIA/apg/patterns/checkbox/examples/checkbox/  -->
          <input type="checkbox" v-model="functionalActive" id="functional-box" />
          <label
            v-html="$t('cookieConsent.categoryFunctional.text')"
            @click="() => {}"
            for="functional-box"
            data-qe-id="functional-accept-desc"
          >
          </label>
        </div>
        <t-toggle-box :title="$t('cookieConsent.main.moreinfo_textlink')" qe-id="xxx">
          <div v-html="md($t('cookieConsent.categoryFunctional.details_md'))"></div>
        </t-toggle-box>
      </div>

      <div class="marketing">
        <h3>{{ $t('cookieConsent.categoryMarketing.title') }}</h3>
        <div class="checkbox-group">
          <input type="checkbox" v-model="marketingActive" id="marketing-box" />
          <label
            v-html="$t('cookieConsent.categoryMarketing.text')"
            @click="() => {}"
            for="marketing-box"
            data-qe-id="marketing-accept-desc"
          >
          </label>
        </div>
        <t-toggle-box :title="$t('cookieConsent.main.moreinfo_textlink')" qe-id="xxx">
          <div v-html="md($t('cookieConsent.categoryMarketing.details_md'))"></div>
        </t-toggle-box>
      </div>
    </t-text>
    <div class="button-bar">
      <t-button class="consent-button accept-all" midGreen @click="onConfirmAllClick" data-qe-id="button-all">{{
        $t('cookieConsent.main.button_1')
      }}</t-button>
      <t-button class="consent-button accept-custom" yellow @click="onConfirmCustomClick" data-qe-id="button-custom">{{
        $t('cookieConsent.main.button_2')
      }}</t-button>
    </div>
  </t-container>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { marked } from 'marked'
import { GD, Storage, STORE_NAME } from '@gd/storage'
import { ACTION } from '@gd/tracking'
import { postSettings } from '../lib/request'
import { track } from '../lib/track'
import { events } from '@gd/event-bus'

const emit = defineEmits(['close'])

const storage = new Storage()
const functionalActive = ref(true)
const marketingActive = ref(false)

const cookieConsent = (storage.read(STORE_NAME.GD) as GD).cookieConsent
if (cookieConsent && cookieConsent.consented) {
  functionalActive.value = cookieConsent.functional
  marketingActive.value = cookieConsent.marketing
}

onMounted(() => {
  track({
    id: 'consent_settings',
    action: ACTION.show,
  })
})

function md(text: string) {
  return marked(text)
}

function onConfirmCustomClick() {
  submitSelection({ functional: functionalActive.value, marketing: marketingActive.value })
  track({
    id: 'consent_settings',
    elem: 'button_consent_custom',
    action: ACTION.click,
  })
}

function onConfirmAllClick() {
  submitSelection({ functional: true, marketing: true })
  track({
    id: 'consent_settings',
    elem: 'button_consent_all',
    action: ACTION.click,
  })
}

function submitSelection(data: GD_cookieConsent.CookieConsentPost) {
  postSettings(data)
    .then(() => {
      let eventPayload = { functional: data.functional, marketing: data.marketing }
      events.$emit('cookie-consent', eventPayload)
      emit('close')
    })
    .catch(() => {
      emit('close')
    })
}
</script>

<style lang="less"></style>
